<ul class="flex space-x-2 rtl:space-x-reverse mb-5">
    @for (item of breadcrumbItems(); track item.label; let i = $index) {
        <li
            [ngClass]="{
                'before:content-[\'/\']': i > 0,
                'ltr:before:mr-2': true,
                'rtl:before:ml-2': true,
            }"
        >
            @if (item.url && i !== breadcrumbItems().length - 1) {
                <a
                    [routerLink]="item.url"
                    class="hover:underline gap-2"
                    [ngStyle]="{ display: i === 0 ? 'inline-flex' : 'inline' }"
                >
                    <svg
                        *ngIf="i === 0"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                            fill="#D0AC6B"
                        />
                        <path
                            d="M12 5L6.5 11L4 8.273"
                            fill="#D0AC6B"
                        />
                        <path
                            d="M12 5L6.5 11L4 8.273"
                            stroke="white"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    <span>
                        {{ item.label }}
                    </span>
                </a>
            } @else {
                <span
                    [ngClass]="{
                        'text-primary': i === breadcrumbItems().length - 1,
                    }"
                >
                    {{ item.label }}
                </span>
            }
        </li>
    }
</ul>
